import React, { useMemo } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import PropTypes from 'prop-types';

import { Hotkey } from 'ui-components/components/hotkey';

export const messages = defineMessages({
  name: {
    description: 'Go to the previous record in the Orders grid',
    defaultMessage: 'Go to Previous Order',
    id: 'Bx9Of4',
  },
});

export const hotkey = ['UpArrow'];
export const barcodeContent = '+GNB6J4W4B9KG=';

const GoToNextPreviousHotkey = ({ children = null, actionHandler }) => {
  const intl = useIntl();
  const hotkeyMetadata = useMemo(
    () => ({
      barcode: barcodeContent,
      displayHotkeyStrings: hotkey,
      hotkey,
      handler: actionHandler,
      name: intl.formatMessage(messages.name),
      legacyCategory: 'general',
      doNotTrack: false,
    }),
    [intl, actionHandler],
  );

  return <Hotkey hotkey={hotkeyMetadata}>{children}</Hotkey>;
};

GoToNextPreviousHotkey.propTypes = {
  children: PropTypes.node,
  actionHandler: PropTypes.func.isRequired,
};

export default GoToNextPreviousHotkey;
